import { createFileRoute } from "@tanstack/react-router";
import { CommCenter } from "@/components/comm/comm-center";

export const Route = createFileRoute("/parent/comms")({ component: () => <CommCenter role="parent" /> });
